const DepthSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="41"
      viewBox="0 0 17 41"
      fill="none"
    >
      <path d="M1 0V36C1 38.2091 2.79086 40 5 40H17" stroke="#E2E8F0" />
    </svg>
  );
};

export const DepthIcon = () => {
  return (
    <div className={`w-[16px] h-[32px] opacity-60 stroke-[#E2E8F0] `}>
      <DepthSvg />
    </div>
  );
};
